import { useState } from "react";
import { useTranslations } from "../hooks/useTranslations.ts";
import { webComponent } from "../services/webComponentService.ts";

function HeroVideoControls() {
	const t = useTranslations();
	const [isPlaying, setIsPlaying] = useState(true);

	function onPlayClick() {
		const videoElement = document.getElementById("hero-video") as HTMLVideoElement;
		videoElement.play();
		setIsPlaying(true);
	}

	function onPauseClick() {
		const videoElement = document.getElementById("hero-video") as HTMLVideoElement;
		videoElement.pause();
		setIsPlaying(false);
	}

	return (
		<>
			{isPlaying ? (
				<button className="absolute bottom-10 left-10" onClick={onPauseClick} aria-label={t.pause}>
					<img
						alt=""
						aria-hidden="true"
						src="/_esfn/icons/pause-circle.svg"
						className="filter-white w-10"
					/>
				</button>
			) : (
				<button className="absolute bottom-10 left-10" onClick={onPlayClick} aria-label={t.play}>
					<img
						alt=""
						aria-hidden="true"
						src="/_esfn/icons/play-circle.svg"
						className="filter-white w-10"
					/>
				</button>
			)}
		</>
	);
}

export default webComponent("hero-video-controls", HeroVideoControls);
